import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPolygon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-polygon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.5 9.5l3.5 -3" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 5.5l3 1.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M18.5 10l-2.5 7" }),
		/* @__PURE__ */ _jsx("path", { d: "M13.5 17.5l-7 -5" })
	]
});
const ForwardRef = forwardRef(SvgPolygon);
export default ForwardRef;
